import { render, staticRenderFns } from "./VideoRequestPublic.vue?vue&type=template&id=bba50aca&scoped=true&"
import script from "./VideoRequestPublic.vue?vue&type=script&lang=js&"
export * from "./VideoRequestPublic.vue?vue&type=script&lang=js&"
import style0 from "./VideoRequestPublic.vue?vue&type=style&index=0&id=bba50aca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba50aca",
  null
  
)

export default component.exports